export default __webpack_public_path__ + "static/media/language.16cef22c.svg";